import { Injectable } from "@angular/core";
import { Observable, Subject, BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CourseDisplayerService {
  private audioActionSource = new Subject<any>();
  private videoActionSource = new Subject<any>();
  private audioStatusSource = new Subject<any>();
  private audioSpeedSource = new BehaviorSubject(1);
  private currentChunkIndexSource = new Subject<any>();
  private scrollEventSource = new Subject<any>();
  private currentChunkSource = new BehaviorSubject(false);
  private currentChunkBeingReadSource = new Subject<any>();
  private previousButtonIsAvailableSource = new BehaviorSubject(false);
  private playButtonIsAvailableSource = new BehaviorSubject(false);
  private nextButtonIsAvailableSource = new BehaviorSubject(false);
  private courseSource = new BehaviorSubject(null);

  /* est l'action qui est envoyé par le bouton de audio-command */
  audioAction$ = this.audioActionSource.asObservable();
  loading = false;
  /*
  Le statut représente l'état du lecteur audio. Lorsque la commande "play" est utilisé 
  un statut "playing" est renvoyé
  */
  videoAction$ = this.videoActionSource.asObservable();
  scrollEvent$ = this.scrollEventSource.asObservable();
  currentChunk$ = this.currentChunkSource.asObservable();
  currentChunkBeingRead$ = this.currentChunkBeingReadSource.asObservable();
  audioStatus$ = this.audioStatusSource.asObservable();
  audioSpeed$ = this.audioSpeedSource.asObservable();
  currentChunkIndex$ = this.currentChunkIndexSource.asObservable();
  previousButtonIsAvailable$ =
    this.previousButtonIsAvailableSource.asObservable();
  playButtonIsAvailable$ = this.playButtonIsAvailableSource.asObservable();
  nextButtonIsAvailable$ = this.nextButtonIsAvailableSource.asObservable();
  course$ = this.courseSource.asObservable();

  constructor() {}

  setCurrentChunkBeingRead(chunk) {
    this.currentChunkBeingReadSource.next(chunk);
  }
  passScrollEvent(scrollEvent) {
    this.scrollEventSource.next(scrollEvent);
  }
  passAudioAction(audioAction) {
    this.audioActionSource.next(audioAction);
  }
  passVideoAction(videoAction) {
    this.videoActionSource.next(videoAction);
  }
  setAudioStatus(audioStatus) {
    this.audioStatusSource.next(audioStatus);
  }
  resetAudioStatus() {
    this.audioStatusSource.next(undefined);
  }
  setAudioSpeed(audioSpeed) {
    localStorage.setItem("audio-playback-rate", audioSpeed + "");
    this.audioSpeedSource.next(audioSpeed);
  }
  previousButtonIsAvailable(status) {
    this.previousButtonIsAvailableSource.next(status);
  }
  playButtonIsAvailable(status) {
    this.playButtonIsAvailableSource.next(status);
  }
  nextButtonIsAvailable(status) {
    this.nextButtonIsAvailableSource.next(status);
  }
  passCourse(course) {
    this.courseSource.next(course);
  }

  setCurrentChunkIndex(currentChunkIndex, currentChunk) {
    this.currentChunkIndexSource.next(currentChunkIndex);
    this.currentChunkSource.next(currentChunk);
  }
}
